module.exports = __webpack_public_path__ + "img/close_ic.b5e4103a.svg";